<template>
    <div class="page-setting has-bc batch-house">
        <!-- <alart-msg :display="error.status" styleType="error" @alartStatus="error.status = false">
            <span class="title" slot="title">{{error.msg}}</span>
        </alart-msg> -->
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group" :class="{'fixed-save': batchList.length > 0}">
                <a @click="$analyticsBiz.logEvent('下載批次Excel檔案', { screen_name: '下載批次Excel檔案'})" href="https://flypig-public.s3.ap-southeast-1.amazonaws.com/doc/batch_upload_company_v1.0.9.xlsx">
                    <button class="batch-button download">
                        <img src="@/assets/img/icon/biz_download_gray.svg" alt="">
                        檔案下載
                    </button>
                </a>
                <button v-if="batchList.length > 0"  @click="saveBatch" class="default-button save">完成</button>
                <button v-else-if="bizAuth.createHouse.hasRight" class="batch-button upload" @click="uploadFile(), $analyticsBiz.logEvent('上傳批次Excel檔案', { screen_name: '上傳批次Excel檔案'})">
                    <img src="@/assets/img/icon/biz_upload_gray.svg" alt="">
                    上傳檔案
                    <input type="file" id="avatar" ref="upload" name="avatar">
                </button>
            </div>
        </div>
        <toogle-block>
            <div class="toogle-title-wrap" slot="toogle-title">
                <!-- <img src="@/assets/img/icon/info_gray.svg" alt=""> -->
                流程說明：
            </div>
            <div class="toogle-body-wrap" slot="toogle-body">
                <ul>
                    <li>1. 下載範例excel</li>
                    <li>2. 依照excel說明，填入房源訊息，若您的房源有多個業務，請先到<router-link :to="{ name: 'bizAccountMgt'}"> 員工帳號 </router-link>建立帳號</li>
                    <li>3. 上傳excel</li>
                    <li>4. 更新房源圖片</li>
                    <li class="li-alarm">注意：上傳的第一張圖片會預設為封面，可再編輯封面圖片</li>
                </ul>
            </div>
        </toogle-block>
        <div class="upload-error" v-if="error.status">
            <div class="title">
                <img src="@/assets/img/icon/alarm_msg_error.svg" alt="" srcset="">
                excel 上傳錯誤，請重新上傳
            </div>
            <div class="content" v-html="error.msg"></div>
        </div>
        <span v-if="batchErrList.length > 0" class="err-count">{{batchErrList.length}} 筆資料上傳失敗</span>
         <ul v-if="batchErrList.length > 0" class="err">
            <li v-for="(house, index) in batchErrList" :key="index" >
                <div class="house-item-head">
                    <span class="order">{{index+1}}</span>
                    <span class="name">{{house.name}}</span>
                    <span class="address">{{house.address}}</span>
                </div>
                <upload-batch-img :houseIndex="index"></upload-batch-img>
            </li>
        </ul>
        <ul v-else>
            <li v-for="(house, index) in batchList" :key="index" >
                <div class="house-item-head">
                    <span class="order">{{index+1}}</span>
                    <span class="name">{{house.name}}</span>
                    <span class="address">{{house.address}}</span>
                </div>
                <upload-batch-img :houseIndex="index"></upload-batch-img>
            </li>
        </ul>
    </div>
</template>
<script>
import XLSX from "xlsx";
import FileUpload from 'vue-upload-component';
import uploadBatchImg from '@/components/bussiness/mgtCategory/houseMgt/batchHouse/uploadBatchImg.vue';
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import { mapGetters } from 'vuex'

export default {
     data () {
        return {
            houseExcel: null,
            houseBatchInfo: [],
            files: [],
            uploadImagesCount: 0
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent('批次新增', { screen_name: '批次新增'})
        setTimeout(()=>{
            document.getElementById("avatar").addEventListener("change", e => {
                this.uploadExcel(e);
            });
        }, 200)
        
    },
    destroyed () {
        this.$store.commit('bizBatchUpload/set_default')
        this.$store.commit('bizBatchUpload/set_fail', {status: false})
    },
    methods: {
        uploadExcel: function (e) {
            this.$store.dispatch('bizUploadBatch', e)
            .then( () => {
                this.readExcel(e)
            })
        },
        uploadFile: function () {
            document.getElementById("avatar").click()
        },
        saveBatch: function () {
            this.$store.dispatch('setAlarmStatus', {status: true,title: '批次刊登房源成功',type: 'success'})
            this.$router.push({ name: 'bizHouseMgtDefault'})
            // this.$store.dispatch('setImageCount').then(()=>{
            //     if(this.batchErrList.length > 0){
            //         this.$store.dispatch('saveErrBatch')
            //         .then((val)=>{
            //             if(val == 'done'){
            //                 this.$router.push({ name: 'bizHouseMgtDefault', query: { success: '1' }})
            //             }
            //         })
            //     }else{
            //         this.$store.dispatch('saveBatch')
            //         .then((val)=>{
            //             if(val == 'done'){
            //                 this.$router.push({ name: 'bizHouseMgtDefault', query: { success: '1' }})
            //             }else{
                            
            //             }
            //         })
            //     }
            // })
            // this.uploadImages.map((image) => {
            //     if(image.length > 0){
            //         this.uploadImagesCount++
            //     }
            // })
            // console.log(this.uploadImagesCount)
            // if(this.batchErrList.length > 0){
            //     this.$store.dispatch('saveErrBatch')
            // }else{
            //     this.$store.dispatch('saveBatch')
            // }
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                // console.log('response', newFile.response)
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                return prevent()
                }
            }
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        readExcel: function(e) {
            var _self = this
            const files = e.target.files
            const fileReader = new FileReader()

            fileReader.onload = ev =>{
                try{
                    _self.dsActors = []
                    const data = ev.target.result
                    const workbook = XLSX.read(data, {
                        type: "binary"
                    })
                    var sheet_name_list = workbook.SheetNames
                    const ws = XLSX.utils.sheet_to_json(
                        workbook.Sheets[sheet_name_list[0]],
                        { header: 1 }
                    )
                    this.$store.dispatch('setBizBatchExcle' , ws)
                }catch (e) {
                    return false;
                }
            }
            fileReader.readAsBinaryString(files[0]);
        },
        // getHouseName: function (val) {
        //     if(val){
        //         return val
        //     }else{
        //         return '未填寫房源'
        //     }
        // },
        // getLane: function (val) {
        //     if(val){
        //         return val+'巷'
        //     }else{
        //         return ''
        //     }
        // },
        // getAlley: function (val) {
        //     if(val){
        //         return val+'弄'
        //     }else{
        //         return ''
        //     }
        // },
        // getNumber: function (val) {
        //     if(val){
        //         return val+'號'
        //     }else{
        //         return ''
        //     }
        // },
        // getDash: function (val) {
        //     if(val){
        //         return '之'+val
        //     }else{
        //         return ''
        //     }
        // },
        // getFloor: function (val) {
        //     if(val){
        //         return ','+val+'樓'
        //     }else{
        //         return ''
        //     }
        // },
        // getRoom: function (val) {
        //     if(val){
        //         return '之'+val
        //     }else{
        //         return ''
        //     }
        // }
    },
    computed: {
        ...mapGetters({
            batchList: 'GET_BIZ_BATCH_LIST',
            batchErrList: 'GET_BIZ_BATCH_ERROR_LIST',
            error: 'GET_BIZ_BATCH_FAIL',
            bizAuth: 'GET_BIZ_AUTH',
            // uploadImages: 'GET_UPLOAD_IMAGES'
        })
    },
    components:{
        FileUpload,
        uploadBatchImg,
        toogleBlock,
    }
}
</script>
<style lang="scss">
    .batch-house{
        .page-header{
            .btn-group{
                .batch-button{
                    width: 120px;
                    height: 44px;
                    border-radius: 4px;
                    border: solid 1px #e3e4e3;
                    background-color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    >img{
                        margin-right: 4px;
                    }
                    #avatar{
                        display: none;
                    }
                }
                .download{
                    margin-right: 12px;
                }
                .save{
                    width: 120px;
                    height: 42px;
                }
            }
        }
        .toggle-block{
            width: 100%;
            .toogle-title-wrap{
                display: flex;
                line-height: 1.38;
                margin-bottom: -4px;
                font-size: 14px;
                color: #292625;
                img{
                    margin-right: 4px;
                }
            }
            .toogle-body-wrap{
                ul{
                    >li{
                        font-weight: 300;
                        margin-bottom: 12px;
                        a{
                            color: #3942B5;
                        }
                    }
                    >li.li-alarm{
                        color: #fc7171;
                    }
                }
            }
        }
        .err-count{
            display: block;
            margin-bottom: 24px;
            font-size: 20px;
            font-weight: 500;
            color: #fc7171;
        }
        .upload-error{
            backdrop-filter: blur(10px);
            border: solid 1px #fb6b63;
            background-color: #ffffff;
            border-radius: 6px;
            padding: 24px;
            box-sizing: border-box;
            .title{
                display: flex;
                align-items: center;
                color: #fc7171;
                margin-bottom: 8px;
                >img{
                    width: 16px;
                    margin-right: 6px;
                }
            }
            .content{
                line-height: 1.71;
                color: #676362;
            }
        }
        >ul{
            >li{
                position: relative;
                width: 1144px;
                // height: 150px;
                border-radius: 6px;
                border: solid 1px #f0f0f0;
                background-color: #ffffff;
                padding: 20px;
                margin-bottom: 24px;
                box-sizing: border-box;
                .house-item-head{
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-bottom: 4px;
                    .order{
                        color: #ff9275;
                        font-weight: 300;
                    }
                    .name{
                        font-size: 20px;
                        margin: 0 12px;
                    }
                    .address{
                        font-weight: 300;
                    }
                }
            }
        }
    }
    // @media screen and (max-width: 1280px) {
    //     .batch-house{
    //         >ul{
    //             >li{
    //                 width: 1101px;
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/batchHouse/BatchHouse.vue